import { TSearchResult } from "../search-results/search-results";
import styles from "./search-number-of-results.module.less";
import { useTranslation } from "react-i18next";

export type TSearchNumberOfResultsProps = {
  results: Array<TSearchResult> | undefined | null;
  hasError: boolean;
  isLoading: boolean;
};

const getNumberOfResults = (
  results: Array<TSearchResult> | undefined | null,
  isLoading: boolean,
  hasError: boolean
): string => {
  const { t } = useTranslation();

  if (isLoading) {
    return t("SEARCH_IS_LOADING");
  }

  if (hasError) {
    return t("SEARCH_GENERAL_ERROR");
  }

  if (!results) {
    return t("SEARCH_NOT_SEARCHED_YET");
  }

  return `${results?.length ?? 0} ${t("SEARCH_RESULTS_FOUND")}`;
};

const SearchNumberOfResults = ({ results, isLoading, hasError }: TSearchNumberOfResultsProps) => {
  return (
    <div className={styles.wrapper}>
      <p className={["eyebrow", styles.text, hasError ? styles.error : ""].join(" ")}>
        {getNumberOfResults(results, isLoading, hasError)}
      </p>
    </div>
  );
};

export default SearchNumberOfResults;
